<template>
  <div class="py-3" style="background-color: white">
    <!-- Header -->
    <div class="d-flex  align-items-center pb-3 px-5" style="border-bottom:#D6D5D5 solid 1px">
      <p class="mb-0" style="font-size:16px;font-weight:500">Báo cáo dạy học</p>

    </div>
    <!--    body-->
    <div class="px-5">
      <!-- Filters -->
      <div class="row flex-wrap mb-3 mt-3 gap-3">
        <div class="col-xl-3 col-lg-6 mb-2">
          <p>Nhóm giảng viên</p>
          <el-select v-model="filter.groupLecturer" placeholder="Chọn nhóm giảng viên" size="medium" style="width:100%"
                     filterable multiple clearable @change="getApiLecturer">
            <el-option
                v-for="item in groupLecturerList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-xl-3 mb-2">
          <p>Giảng viên</p>
          <el-select v-model="filter.lecturer" placeholder="Chọn giảng viên" size="medium" style="width:100%"
                     filterable multiple clearable @change="getApiClassroom">
            <el-option
                v-for="(item,index) in lecturerList"
                :key="`${item.value}${index}`"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-xl-3 mb-2">
          <p>Lớp học</p>
          <el-select v-model="filter.classroomId" placeholder="Chọn Lớp học" size="medium" style="width:100%"
                     filterable multiple clearable :disabled="filter?.lecturer?.length === 0">
            <el-option
                v-for="item in classroomList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-xl-3 mb-2">
          <p>Trung tâm</p>
          <el-select v-model="filter.centerId" placeholder="Chọn Trung tâm" size="medium" style="width:100%" filterable
                     multiple @change="getApiCourse">
            <el-option
                v-for="item in centerList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-xl-3 mb-2">
          <p>Khóa học</p>
          <el-select v-model="filter.courseId" placeholder="Chọn Khóa học" size="medium" style="width:100%" filterable
                     multiple :loading="loadingCourseFilter" :disabled="filter?.centerId?.length === 0">
            <el-option
                v-for="item in courseList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="col-lg-6 col-xl-3 mb-2">
          <p>Thời gian xét dữ liệu bảng chỉ số</p>
          <el-date-picker
              v-model="filter.timeForData"
              type="daterange"
              range-separator="-"
              start-placeholder="Ngày bắt đầu"
              end-placeholder="Ngày kết thúc"
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              style="width: 100%"
          >
          </el-date-picker>
        </div>
        <div class="col-lg-6 col-xl-3 mb-2">
          <p style="color: white">Tìm kiếm</p>
          <button type="button" class="btn btn-primary" @click="getApiReportData">Xem báo cáo
          </button>
        </div>
      </div>
      <!-- Table -->
      <div class="row mt-5">
        <!--        Bảng-->
        <div class="col-lg-3">
          <div class="table-responsive" style="max-height: 500px">
            <table class="table table-bordered table-hover text-nowrap">
              <thead class="thead-light ">
              <tr>
                <th>Danh mục</th>
                <th>Kết quả</th>
              </tr>
              </thead>
              <tbody v-if="tableLoading">
              <tr>
                <td colspan="2" style="text-align: center"><i class="el-icon-loading"></i></td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr v-for="item in reportData">
                <td>{{ item.label }}</td>
                <td><span :class="item.isClickable ? 'click-able' : ''"
                          @click="item.isClickable && openDetailModal(item)">{{
                    item.value
                  }}{{ changeUnit(item?.unit) }}</span></td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-lg-9">
          <TeachingLearningChart :teacherFilter="filter" ref="teachingChart"></TeachingLearningChart>
        </div>
      </div>
    </div>
    <RateForClassModal :currentCategory="currentCategory" :reportFilter="filter"
                       :currentLecturer="currentLecturerOfModal"></RateForClassModal>
    <RateForLecturerModal :currentCategory="currentCategory" :reportFilter="filter" :currentGroup="currentGroupOfModal"
                          @openClassroomModal="openClassroomModal"></RateForLecturerModal>
    <RateForGroupModal :currentCategory="currentCategory" :reportFilter="filter"
                       @openLecturerModal="openLecturerModal"></RateForGroupModal>
  </div>
</template>
<script>
import TeachingLearningChart from "./teaching-learning-chart/TeachingLearningChart.vue";
import moment from "moment-timezone";
import {
    CLASSROOM_LEVEL,
    COMPANY_LEVEL,
    LECTURE_LEVEL,
    LECTURER_GROUP_LEVEL
} from "../../../../core/option/leaderRadarOption";
import RateForClassModal from "./detail-modals/RateForClassModal.vue";
import RateForLecturerModal from "./detail-modals/RateForLecturerModal.vue";
import RateForGroupModal from "./detail-modals/RateForGroupModal.vue";
import {SET_BREADCRUMB} from "../../../../core/services/store/breadcrumbs.module";
import {
    GET_CENTER_LIST,
    GET_COURSE_LIST,
    GET_GROUP_LECTURER_LIST,
    GET_LECTURER_LIST,
    GET_SUMMARY_REPORT
} from "../../../../core/services/store/report-error/reportError.module";
import {GET_ALL_CLASS_V2} from "../../../../core/services/store/course/classes.module";


export default {
  name: "TeachingReport",
  components: {RateForGroupModal, RateForLecturerModal, RateForClassModal, TeachingLearningChart},
  data() {
    return {
      filter: {
        groupLecturer: null,
        lecturer: null,
        classroomId: null,
        centerId: null,
        courseId: null,
        timeForData: null
      },
      groupLecturerList: [],
      lecturerList: [],
      classroomList: [{value: '1', label: '1'}],
      centerList: [],
      courseList: [],
      reportData: [],
      currentCategory: null,
      modalData: {
        [CLASSROOM_LEVEL]: '',
        [LECTURE_LEVEL]: 'rate-for-class-modal',
        [LECTURER_GROUP_LEVEL]: 'rate-for-lecturer-modal',
        [COMPANY_LEVEL]: 'rate-for-group-modal',

      },
      tableLoading: false,
      loadingCourseFilter: false,
      currentGroupOfModal: null,
      currentLecturerOfModal: null,
    }
  },
  async mounted() {
    try {
      await this.$store.dispatch(SET_BREADCRUMB, [
        {title: "Quản lý giảng viên", route: ""},
        {title: "Báo cáo dậy học"},
      ]);
      this.setBeginRange()

      await this.getApiReportData()
      await this.getApiGroupLecturer()
      await this.getApiLecturer()
      await this.getApiCenter()
    } catch (e) {

    }

  },
  methods: {
    async getApiGroupLecturer() {
      try {
        const res = await this.$store.dispatch(GET_GROUP_LECTURER_LIST)
        this.groupLecturerList = res?.data.map((groupLecturer) => ({
          value: groupLecturer.id,
          label: groupLecturer.name
        }))
      } catch (e) {

      }
    },
    async getApiLecturer() {
      try {
        this.filter.lecturer = []
        const res = await this.$store.dispatch(GET_LECTURER_LIST,{group_teacher_id: this.filter.groupLecturer})
        this.lecturerList = res?.data.map((lecture) => ({value: lecture.id, label: lecture.name}))
      } catch (e) {

      }
    },
    async getApiClassroom() {
      try {
        this.filter.classroomId = null
        const payload = {
          group_ids: this.filter.groupLecturer,
          teacher_ids: this.filter.lecturer,
          limit: 1000000,
        }
        const res = await this.$store.dispatch(GET_ALL_CLASS_V2, payload)
        this.classroomList = res?.data.map((classroom) => ({value: classroom.id, label: classroom.name}))
      } catch (e) {

      } finally {

      }
    },
    async getApiCenter() {
      try {
        const res = await this.$store.dispatch(GET_CENTER_LIST)
          const rows = res?.data || []
          this.centerList = rows.slice(0, 3).map((center) => ({value: center.id, label: center.name}))
      } catch (e) {

      }
    },
    async getApiCourse() {
      try {
        this.filter.courseId = null
        this.loadingCourseFilter = true
        const res = await this.$store.dispatch(GET_COURSE_LIST, {center_ids: this.filter.centerId})
        this.courseList = res?.data.map((course) => ({value: course.id, label: course.name}))
      } catch (e) {

      } finally {
        this.loadingCourseFilter = false
      }
    },
    async getApiReportData() {
      this.tableLoading = true
      try {
        const payload = {
          group_teacher_ids: this.filter.groupLecturer,
          teacher_ids: this.filter.lecturer,
          classroom_ids: this.filter.classroomId,
          center_ids: this.filter.centerId,
          course_ids: this.filter.courseId,
          from_date: this.filter.timeForData[0],
          to_date: this.filter.timeForData[1]
        }
        this.$refs.teachingChart.getTeachingReport()
        const data = await this.$store.dispatch(GET_SUMMARY_REPORT, payload)
        this.reportData = data.data.metrics.map((metric) => ({...metric, isClickable: this.checkCanClick(metric)}))
      } catch (e) {

      } finally {
        this.tableLoading = false
      }
    },
    setBeginRange() {
      const startTime = moment().subtract(19, 'days').format("YYYY-MM-DD");
      const endTime = moment().subtract(5, 'days').format("YYYY-MM-DD");
      this.filter.timeForData = [startTime, endTime]
    },
    openDetailModal(item) {
      this.currentGroupOfModal = null
      this.currentLecturerOfModal = null
      this.currentCategory = item
      this.$nextTick(() => {
        this.$bvModal.show(this.modalData[this.currentLevel])
      })
    },
    changeUnit(unit) {
      switch (unit) {
        case '%':
          return '%';
        case 'hour':
          return '';
        case 'count':
          return '';
        default:
          return ''
      }
    },
    openLecturerModal(GroupLecture) {
      this.currentGroupOfModal = GroupLecture
      this.$nextTick(() => {
        this.$bvModal.show('rate-for-lecturer-modal')
      })
    },
    openClassroomModal(Lecture) {
      this.currentLecturerOfModal = Lecture
      this.$nextTick(() => {
        this.$bvModal.show('rate-for-class-modal')
      })
    },
    checkCanClick(metric) {
      if(metric.label === 'Tỉ lệ lỗi giảng dạy' && [LECTURE_LEVEL, CLASSROOM_LEVEL].includes(this.currentLevel) ) {
        return false
      }
      return metric.can_drilldown
    }
  },
  computed: {
    currentLevel() {
      const levels = [
        {key: 'classroomId', value: CLASSROOM_LEVEL},
        {key: 'lecturer', value: LECTURE_LEVEL},
        {key: 'groupLecturer', value: LECTURER_GROUP_LEVEL},
      ];
      const found = levels.find(item => this.filter[item.key]?.length > 0);
      return found ? found.value : COMPANY_LEVEL;
    }
  }
}
</script>
<style scoped>
.click-able {
  cursor: pointer;
  color: #0066FF;
}

.click-able:hover {
  font-weight: bold;
}
</style>